import * as THREE from 'three';
import { G, mesh } from '../render/scene';
import { MAT_P, coreGlow } from '../render/materials';
import { bevel, joint, mark, plate, ram, rib, seam } from './mech-kit';
import { LSTANCE } from './lancer-pose';
/* ============================================================
   LANCER-2 · 推進器 THRUSTER：骨盆 + 正關節腿 + 背部加速器
   ============================================================

   CHASSIS-0 的腿是「長、細、逆關節、長腳掌」（`mech-legs.ts`）。
   這一台是反過來的：**短、粗、正關節、寬短腳掌、站姿寬 ±0.62**。

   健體感的作法與 CHASSIS-0 同一條 —— 質量集中在關節上方 —— 但這裡
   加了第三段：股四頭在**中段**最鼓（上段接髖、中段最寬、下段收進膝），
   因為健體體型的大腿不是錐形而是紡錘形。小腿同理（腓腸在高處鼓）。

   腳掌短而寬（fl < fw × 1.3）是「站得住」的來源：CHASSIS-0 的長腳掌
   讀起來是踮著跑，這一台要讀起來是紮著馬步。 */

function plantLeg(side, cfg) {
  var hip = new THREE.Group();
  hip.position.set(side * LSTANCE.stance, 0, 0);
  hip.rotation.y = -side * 0.10;                 // 腳尖外八，馬步的特徵
  hip.add(joint(0.29, [0, 0, 0], true));                                       // 髖（軸端外露、比 C0 粗）

  var thigh = new THREE.Group(); thigh.userData.bone = 1; hip.add(thigh);
  thigh.add(bevel(MAT_P.dark, cfg.tw * 0.88, 0.26, cfg.tw * 0.86, [0, -0.13, 0]));   // 股上段（接髖）
  thigh.add(bevel(MAT_P.dark, cfg.tw, 0.30, cfg.tw * 0.96, [0, -0.38, 0]));          // 股中段（最鼓）
  thigh.add(bevel(MAT_P.dark, cfg.tw * 0.70, 0.26, cfg.tw * 0.70, [0, -0.66, 0]));   // 股下段（收進膝）
  thigh.add(plate(MAT_P.armor, cfg.tw * 1.14, 0.46, cfg.tw * 0.54, [0, -0.30, cfg.tw * 0.56], -0.16));
  thigh.add(seam(cfg.tw * 1.02, 0.05, 0.10, [0, -0.52, cfg.tw * 0.60], -0.16));
  thigh.add(rib(MAT_P.armor, 0.08, 0.60, 0.08, [side * cfg.tw * 0.56, -0.36, cfg.tw * 0.26], -0.10));
  thigh.add(ram([cfg.tw * 0.46, -0.58, -cfg.tw * 0.46], 0.52, 0.11, 0.09, [0.16, 0, 0]));  // 膝液壓在**後方**
  thigh.add(ram([-cfg.tw * 0.46, -0.58, -cfg.tw * 0.46], 0.52, 0.11, 0.09, [0.16, 0, 0]));

  var knee = new THREE.Group(); knee.position.set(0, -0.80, 0); thigh.add(knee);
  knee.add(joint(0.25, [0, 0, 0], true));
  knee.add(plate(MAT_P.armor, cfg.sw * 1.04, 0.34, cfg.sw * 0.44, [0, 0.02, -cfg.sw * 0.62], 0.20));  // 膝甲朝後

  var shin = new THREE.Group(); shin.userData.bone = 1; knee.add(shin);
  shin.add(bevel(MAT_P.dark, cfg.sw, 0.40, cfg.sw * 1.04, [0, -0.20, 0]));           // 腓腸（高處鼓）
  shin.add(bevel(MAT_P.dark, cfg.sw * 0.62, 0.34, cfg.sw * 0.64, [0, -0.56, 0]));    // 踝上（收細）
  shin.add(plate(MAT_P.armor, cfg.sw * 1.08, 0.44, cfg.sw * 0.52, [0, -0.22, cfg.sw * 0.52], -0.12)); // 脛甲在前
  shin.add(rib(MAT_P.armor, 0.08, 0.52, 0.08, [0, -0.24, cfg.sw * 0.62], -0.12));
  if (cfg.hyd) {
    shin.add(ram([cfg.sw * 0.50, -0.30, -cfg.sw * 0.40], 0.56, 0.11, 0.09));
    shin.add(ram([-cfg.sw * 0.50, -0.30, -cfg.sw * 0.40], 0.56, 0.11, 0.09));
  }

  var ankle = new THREE.Group(); ankle.position.set(0, -0.74, 0); shin.add(ankle);
  ankle.add(joint(0.19, [0, 0, 0]));

  var foot = new THREE.Group(); foot.userData.bone = 1; ankle.add(foot);
  foot.add(mesh(G.box, MAT_P.trim, [cfg.fw, 0.16, cfg.fl], [0, -0.12, cfg.fl * 0.10]));
  foot.add(plate(MAT_P.armor, cfg.fw * 0.90, 0.15, cfg.fl * 0.46, [0, -0.02, cfg.fl * 0.26], -0.12)); // 腳背
  foot.add(rib(MAT_P.armor, cfg.fw * 0.80, 0.07, 0.07, [0, 0.05, cfg.fl * 0.44], -0.12));
  foot.add(bevel(MAT_P.dark, cfg.fw * 0.74, 0.20, 0.30, [0, -0.06, -cfg.fl * 0.34]));  // 後跟（配重）
  foot.add(mesh(G.box, MAT_P.trim, [cfg.fw * 0.34, 0.12, 0.20, ], [side * cfg.fw * 0.30, -0.16, cfg.fl * 0.36])); // 前爪抓地
  return { root: hip, thigh: thigh, shin: shin, foot: foot, side: side };
}

export function lancerCfg(shape) {
  return shape === 'thr-ring' ? { tw: 0.54, sw: 0.47, fw: 0.64, fl: 0.86, hyd: false }
    : shape === 'thr-heavy' ? { tw: 0.72, sw: 0.62, fw: 0.82, fl: 1.00, hyd: true }
      : { tw: 0.62, sw: 0.54, fw: 0.72, fl: 0.92, hyd: false };
}

export function buildLancerLegs(shape, P?) {
  P = P || { glow: coreGlow('core-std') };
  var g = new THREE.Group();
  mark(g, shape, ['thr-ring', 'thr-heavy', 'thr-twin']);
  var cfg = lancerCfg(shape);

  // 骨盆：寬、厚、四片裙甲。腿掛在外面各自算髖高（與 CHASSIS-0 同一個約定）
  var pel = new THREE.Group(); pel.userData.bone = 1;
  pel.position.y = -0.06;
  g.add(pel);
  pel.add(bevel(MAT_P.dark, 1.30, 0.46, 0.96, [0, 0.04, 0]));
  pel.add(plate(MAT_P.armor, 0.36, 0.62, 0.84, [0.76, -0.04, 0], 0, -0.20, -0.12));   // 側裙甲（大）
  pel.add(plate(MAT_P.armor, 0.36, 0.62, 0.84, [-0.76, -0.04, 0], 0, 0.20, 0.12));
  pel.add(plate(MAT_P.armor, 0.90, 0.42, 0.22, [0, -0.24, 0.44], 0.38));              // 前裙甲
  pel.add(plate(MAT_P.armor, 1.10, 0.54, 0.24, [0, -0.16, -0.50], -0.32));            // 後裙甲
  pel.add(rib(MAT_P.armor, 0.09, 0.09, 0.92, [0.80, 0.28, 0], 0, -0.20));
  pel.add(rib(MAT_P.armor, 0.09, 0.09, 0.92, [-0.80, 0.28, 0], 0, 0.20));
  pel.add(mesh(G.box, P.glow, [0.26, 0.05, 0.05], [0, -0.30, 0.56]));                 // 骨盆下緣的一線光

  var L = plantLeg(1, cfg); g.add(L.root);
  var R = plantLeg(-1, cfg); g.add(R.root);
  g.userData.rig = { pelvis: pel, legs: [L, R], cfg: cfg };
  return g;
}

/* 背部加速器。CHASSIS-0 的背包是「滯空用」，這一台是**貼身用**：
   噴口小顆、數量多、朝向散開 —— 讀起來是姿勢控制而不是巡航。
   `nozzles` 給特效層掛火焰：[x, y, z, 口徑, 傾角]。 */
export function buildLancerBack(shape, P?) {
  P = P || { glow: coreGlow('core-std') };
  var g = new THREE.Group();
  mark(g, shape, ['thr-ring', 'thr-heavy', 'thr-twin']);
  g.userData.nozzles =
    shape === 'thr-ring' ? [[0.30, -0.10, -0.44, 0.34, 0.20], [-0.30, -0.10, -0.44, 0.34, 0.20]]
      : shape === 'thr-heavy' ? [[0.46, -0.22, -0.50, 0.32, 0.34], [-0.46, -0.22, -0.50, 0.32, 0.34],
      [0, -0.36, -0.42, 0.26, 0.52]]
        : [[0.40, -0.18, -0.46, 0.28, 0.30], [-0.40, -0.18, -0.46, 0.28, 0.30]];
  g.userData.vents = [[0.56, 0.34, -0.14], [-0.56, 0.34, -0.14]];

  g.add(bevel(MAT_P.dark, 1.06, 0.56, 0.38, [0, 0.10, -0.04]));                    // 背包本體（寬扁）
  g.add(plate(MAT_P.armor, 1.10, 0.20, 0.42, [0, 0.42, -0.06], -0.26));
  g.add(rib(MAT_P.armor, 1.12, 0.08, 0.08, [0, 0.52, 0.12], -0.26));

  if (shape === 'thr-ring') {
    g.add(mesh(G.tor, MAT_P.armor, [0.78, 0.78, 0.24], [0.34, -0.08, -0.30], [0.22, 0, 0]));
    g.add(mesh(G.tor, MAT_P.armor, [0.78, 0.78, 0.24], [-0.34, -0.08, -0.30], [0.22, 0, 0]));
    g.add(mesh(G.tor, P.glow, [0.56, 0.56, 0.18], [0.34, -0.08, -0.30], [0.22, 0, 0]));
    g.add(mesh(G.tor, P.glow, [0.56, 0.56, 0.18], [-0.34, -0.08, -0.30], [0.22, 0, 0]));
  } else if (shape === 'thr-heavy') {
    g.add(bevel(MAT_P.dark, 0.40, 0.42, 0.40, [0.46, -0.14, -0.32], [0.34, 0, 0]));
    g.add(bevel(MAT_P.dark, 0.40, 0.42, 0.40, [-0.46, -0.14, -0.32], [0.34, 0, 0]));
    g.add(bevel(MAT_P.dark, 0.34, 0.36, 0.34, [0, -0.28, -0.26], [0.52, 0, 0]));
    g.add(mesh(G.cone, P.glow, [0.28, 0.28, 0.28], [0.46, -0.26, -0.42], [-Math.PI / 2 + 0.34, 0, 0]));
    g.add(mesh(G.cone, P.glow, [0.28, 0.28, 0.28], [-0.46, -0.26, -0.42], [-Math.PI / 2 + 0.34, 0, 0]));
    g.add(mesh(G.box, MAT_P.trim, [0.28, 0.46, 0.30], [0.70, 0.18, -0.10]));        // 外掛配重
    g.add(mesh(G.box, MAT_P.trim, [0.28, 0.46, 0.30], [-0.70, 0.18, -0.10]));
  } else {
    g.add(bevel(MAT_P.dark, 0.36, 0.44, 0.36, [0.40, -0.12, -0.28], [0.30, 0, 0]));
    g.add(bevel(MAT_P.dark, 0.36, 0.44, 0.36, [-0.40, -0.12, -0.28], [0.30, 0, 0]));
    g.add(mesh(G.box, P.glow, [0.24, 0.26, 0.06], [0.40, -0.28, -0.40], [0.30, 0, 0]));
    g.add(mesh(G.box, P.glow, [0.24, 0.26, 0.06], [-0.40, -0.28, -0.40], [0.30, 0, 0]));
    g.add(plate(MAT_P.armor, 0.18, 0.38, 0.34, [0.62, 0.12, -0.04], 0, 0, -0.34));  // 側鰭（只一邊大）
  }
  g.add(seam(1.00, 0.05, 0.36, [0, 0.28, -0.04]));
  return g;
}
